const initialState = {
    searchKeyword: '',
    searchType: 'name'
};

const GlobalSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_SEARCH_KEYWORD":
            return {
                ...state,
                searchKeyword: action.payload
            };
        case "UPDATE_SEARCH_TYPE":
            return {
                ...state,
                searchType: action.payload
            };
        default:
            return state;
    }
};

export default GlobalSearchReducer;
